import pageImage from "AdvisoryManagement/Assets/Images/Extranety.png";

export const ExtranetyPage = () => {
	return (
		<img
			src={pageImage}
			alt="ELIS"
			style={{ maxWidth: "100%", height: "auto" }}
		/>
	);
};
